import { CART_COUNT } from '../classnames/cart-popup';
import { HIDDEN } from '../classnames/design-system';

export default class CartHandler {
  handle = ({ itemCount }) => {
    this.updateCartCount({ itemCount });
  };

  updateCartCount = ({ itemCount }) => {
    const elements = document.querySelectorAll(`.${CART_COUNT}`);

    [...elements].forEach((element) => {
      if (itemCount > 0) {
        element.classList.remove(HIDDEN);
      } else {
        element.classList.add(HIDDEN);
      }
      element.innerText = itemCount;
    });
  };
}
